import { ExtensionTag, MarkExtension } from '@remirror/core';

export class InlineCommentExtension extends MarkExtension {
  static disableExtraAttributes = true;

  get name() {
    return 'inlineComment';
  }

  createTags() {
    return [ExtensionTag.FormattingMark];
  }

  createMarkSpec() {
    return {
      attrs: {
        threadId: { default: '' },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: 'span[data-thread-id]',
          getAttrs: (dom) => {
            const el = dom;
            return {
              threadId: el.getAttribute('data-thread-id') || '',
            };
          },
        },
      ],
      toDOM: (mark) => [
        'span',
        {
          'data-thread-id': mark.attrs.threadId,
          class: 'inline-comment',
        },
        0,
      ],
    };
  }

  /**
   * Command to apply the commentThread mark to a range.
   */
  createCommands() {
    return {
      addCommentThread:
        (attrs, from, to) =>
        ({ tr, dispatch, state }) => {
          const { schema, selection } = state;
          const markType = schema.marks.commentThread;
          const mark = markType.create(attrs);
          const start = from ?? selection.from;
          const end = to ?? selection.to;

          if (start === end) return false; // Don't add comment on empty selection
          tr.addMark(start, end, mark);
          if (dispatch) dispatch(tr);
          return true;
        },
    };
  }

  createEventHandlers() {
    return {
      clickMark: (event, clickState) => {
        event.preventDefault();
        const markRange = clickState.getMark(this.type);
        if (!markRange) return;
        const attrs = markRange.mark.attrs;
        const ce = new CustomEvent('thread-clicked', { detail: { threadId: attrs?.threadId } });
        window.dispatchEvent(ce);
      },
    };
  }
}

export default InlineCommentExtension;
